module.exports = __webpack_public_path__ + "img/pseudopp.f33d9178.jpg";